import { render, staticRenderFns } from "./OnboardingComplete.vue?vue&type=template&id=f583b122&scoped=true"
import script from "./OnboardingComplete.vue?vue&type=script&lang=js"
export * from "./OnboardingComplete.vue?vue&type=script&lang=js"
import style0 from "./OnboardingComplete.vue?vue&type=style&index=0&id=f583b122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f583b122",
  null
  
)

export default component.exports